import { render, staticRenderFns } from "./SiteNotificationDetails.vue?vue&type=template&id=1e251ba5&"
import script from "./SiteNotificationDetails.vue?vue&type=script&lang=js&"
export * from "./SiteNotificationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports